/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ApiToken = core.serialization.object({
    clientId: core.serialization.string(),
    description: core.serialization.string(),
    metadata: core.serialization.record(core.serialization.string(), core.serialization.any()),
    createdAt: core.serialization.string(),
    secret: core.serialization.string().optional(),
});
